import { Component, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';

@Component({
    selector: 'mobile-dropdown-nav',
    templateUrl: 'mobile-dropdown-nav.component.html'
})
export class MobileDropDownComponent implements AfterViewInit, OnDestroy {
    thirdNavLinks: any[];
    selectedThirdPageId: any;
    navigation: NxiNavigation;
    layout: string;
    selectedMenuItem: any;
    @ViewChild('menuSelect', {static : false}) select;
    constructor(private translationService: PershingTranslationService, private navigationService: PortalNavigationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
    }
    // This was done in ngOnInit
    // Variables injected via viewChild will be filled and available only after AfterViewInit lifecycle
    ngAfterViewInit(): void {
        console.log(' In Component AfterViewInit ');
        this.navigationService.getChildPage().subscribe(
            currentpage => {
                if (currentpage !== undefined && currentpage.children !== undefined) {
                    this.thirdNavLinks = currentpage.children;
                    console.log(' mob 3rd level' + this.thirdNavLinks);
                }
            });
        this.navigationService.getGrandChildPage().subscribe(
            grandchildpage => {
                if (grandchildpage) {
                    if (grandchildpage.istitle === undefined) {
                        console.log( 'in mob level 3 ===========' + grandchildpage.name);
                        this.select.value = grandchildpage.name;
                        this.selectedMenuItem = grandchildpage.name;
                    }
                }
            }
        );
    }
    public ngOnDestroy() {
        console.log(' In MobileDropDownComponent Destroy ');
    }
    handleNavigation(childpage): void {
        if (this.selectedMenuItem !== childpage.name) {
            this.navigation = new NxiNavigation();
            this.navigation.grandchildPage = childpage;
            this.navigationService.handleNavigation(this.navigation);
        }
    }

    gotoPageEvent(gotoPageName): void {
        if (!(this.selectedMenuItem === 'NXI_NAVIGATION.SECTOR')) {
            document.dispatchEvent(new CustomEvent('portal.gotoview', {
                detail: {
                    'gotoPage': gotoPageName
                }
            }));
        }
    }
}
